import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import './Header.scss';
import { ReactComponent as Logo } from '../../assets/images/LOGO.svg';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import Navbar from './Navbar/Navbar';
import TopMenu from './TopMenu/TopMenu';
import classNames from 'classnames';
import useIsMobile from 'src/hooks/useIsMobile';

function Header() {
  const mobile = useIsMobile();
  const { RETAIL_MODE, TRADING_MODE } = useContext(AppModeContext);

  return (
    <header className={ classNames('header', { 'header--retail': RETAIL_MODE }) }>
      {
        !mobile && (
          <>
            <TopMenu>
              { RETAIL_MODE && <TopMenu.Till /> }
              { !RETAIL_MODE && <TopMenu.Betsite /> }
            </TopMenu>
            {
              !TRADING_MODE && <Link to="/">
                <Logo className="logo" />
              </Link>
            }
            { TRADING_MODE && <a href="/?trading=true"><Logo className="logo" /></a> }
          </>
        )
      }

      <Navbar />
    </header>
  );
}

export default Header;
